import { render, staticRenderFns } from "./MenuCharg.vue?vue&type=template&id=8b48bc7c&scoped=true&"
import script from "./MenuCharg.vue?vue&type=script&lang=js&"
export * from "./MenuCharg.vue?vue&type=script&lang=js&"
import style0 from "./MenuCharg.vue?vue&type=style&index=0&id=8b48bc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b48bc7c",
  null
  
)

export default component.exports